import { __assign, __rest } from "tslib";
import * as React from 'react';
import { StyledIconContainer } from './styles/IconsStyles';
import ArrowDownIcon from './svg/ArrowDown';
import ArrowLeftIcon from './svg/ArrowLeft';
import ArrowRightIcon from './svg/ArrowRight';
import ArrowUpIcon from './svg/ArrowUp';
import CheckmarkCircleIcon from './svg/CheckmarkCircle';
import CheckmarkIcon from './svg/Checkmark';
import ChevronRightIcon from './svg/ChevronRight';
import CloseIcon from './svg/Close';
import DeleteIcon from './svg/Delete';
import DirectionDownIcon from './svg/DirectionDown';
import DirectionUpIcon from './svg/DirectionUp';
import DownloadIcon from './svg/Download';
import ExternalLinkIcon from './svg/ExternalLink';
import FileIcon from './svg/File';
import HomeIcon from './svg/Home';
import InformationIcon from './svg/Information';
import LanguageIcon from './svg/Language';
import LoadingIcon from './svg/Loading';
import LockIcon from './svg/Lock';
import LogoutIcon from './svg/Logout';
import MobilePhoneIcon from './svg/MobilePhone';
import PenIcon from './svg/Pen';
import PlusAddIcon from './svg/PlusAdd';
import QuestionIcon from './svg/Question';
import RemoveIcon from './svg/Remove';
import SearchIcon from './svg/Search';
import MinusIcon from './svg/Minus';
import BackspaceIcon from './svg/Backspace';
import FolderIcon from './svg/Folder';
import FaceIDIcon from './svg/FaceID';
var Icon = function (_a) {
    var Component = _a.icon, _b = _a.color, color = _b === void 0 ? 'currentColor' : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.width, width = _d === void 0 ? 24 : _d, _e = _a.onClick, onClick = _e === void 0 ? function () { return undefined; } : _e, testId = _a.testId, title = _a.title, titleId = _a.titleId, props = __rest(_a, ["icon", "color", "height", "width", "onClick", "testId", "title", "titleId"]);
    return (React.createElement(StyledIconContainer, __assign({ color: color, height: height, width: width, onClick: onClick, "data-testid": testId || "".concat(Component.name, "Icon") }, props),
        React.createElement(Component, { title: title, titleId: titleId })));
};
var generateIcon = function (icon) {
    if (!icon) {
        console.warn('You called generate icon with no icon');
    }
    var name = icon.name;
    var Component = function (props) {
        return React.createElement(Icon, __assign({ icon: icon }, props));
    };
    Component.displayName = "".concat(name, "Icon");
    return Component;
};
var ArrowDown = generateIcon(ArrowDownIcon);
var ArrowLeft = generateIcon(ArrowLeftIcon);
var ArrowRight = generateIcon(ArrowRightIcon);
var ArrowUp = generateIcon(ArrowUpIcon);
var Checkmark = generateIcon(CheckmarkIcon);
var CheckmarkCircle = generateIcon(CheckmarkCircleIcon);
var ChevronRight = generateIcon(ChevronRightIcon);
var Close = generateIcon(CloseIcon);
var Delete = generateIcon(DeleteIcon);
var DirectionDown = generateIcon(DirectionDownIcon);
var DirectionUp = generateIcon(DirectionUpIcon);
var Download = generateIcon(DownloadIcon);
var ExternalLink = generateIcon(ExternalLinkIcon);
var File = generateIcon(FileIcon);
var Home = generateIcon(HomeIcon);
var Information = generateIcon(InformationIcon);
var Language = generateIcon(LanguageIcon);
var Loading = generateIcon(LoadingIcon);
var Lock = generateIcon(LockIcon);
var Logout = generateIcon(LogoutIcon);
var MobilePhone = generateIcon(MobilePhoneIcon);
var Pen = generateIcon(PenIcon);
var PlusAdd = generateIcon(PlusAddIcon);
var Question = generateIcon(QuestionIcon);
var Remove = generateIcon(RemoveIcon);
var Search = generateIcon(SearchIcon);
var Minus = generateIcon(MinusIcon);
var Backspace = generateIcon(BackspaceIcon);
var Folder = generateIcon(FolderIcon);
var FaceID = generateIcon(FaceIDIcon);
export { ArrowDown, ArrowLeft, ArrowRight, ArrowUp, Checkmark, CheckmarkCircle, ChevronRight, Close, Delete, DirectionDown, DirectionUp, Download, ExternalLink, File, Home, Information, Language, Loading, Lock, Logout, MobilePhone, Pen, PlusAdd, Question, Remove, Search, Minus, Backspace, Folder, FaceID, };
//# sourceMappingURL=Icons.js.map